import React, {Component} from 'react';
import moment from 'moment';
import styled from 'styled-components';
import Button from '../common/Button';
import { Link } from 'react-router-dom';

const ButtonC = styled(Button)`
  background: #257CBD;
  color: #fff;
`;

class ParticipantsList extends Component {
  /*constructor(props){
    super(props);
    const emptyMessage = (
        <p>Loading...</p>
    );
  }*/
  
  render(){
    var participantsFiltered = [];
    if(this.props.searchText !== "" && this.props.searchText.length > 3){
      var searchTerm = this.props.searchText;
      this.props.participants.forEach((p)=>{
        if(p.Id.toString().indexOf(searchTerm) !== -1 ){
          participantsFiltered.push(p);
        }
      });
    }else{
      participantsFiltered = this.props.participants;
    }
    
    const participantsList = (
      <div className="col-md-12">
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>BICAMS No.</th>
                <th>Country of Examn</th>
                <th>Gender</th>
                <th>No. of Exams</th>
                <th>Last Exam Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              { participantsFiltered.map(participant => {
                  return <tr key={participant.Id}>
                    <td>{participant.Id}</td>
                    <td>{participant.CountryExam}</td>
                    <td>{participant.Gender}</td>
                    <td>{participant.NoExams}</td>
                    <td>{
                      participant.LastExamDate != null ?
                      moment(participant.LastExamDate).format('DD-MMM-YYYY')
                      : 'N/A'
                      }</td>
                    <td><Link to={`participants/${participant.Id}`}><ButtonC type="button" className="btn btn-lg"><span className="glyphicon glyphicon-zoom-in"></span></ButtonC></Link></td>
                    </tr>
                }) }
            </tbody>
          </table>
        </div>
      </div>
    );
    return (
      <div>
        {this.props.participants.length === 0 ? this.emptyMessage : participantsList}
      </div>
    );
  }
  
};

ParticipantsList.propTypes = {
  participants: React.PropTypes.array.isRequired,
  searchText: React.PropTypes.string.isRequired,
};

export default ParticipantsList;


// WEBPACK FOOTER //
// ./src/components/participants/ParticipantsList.js